"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _WizardNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/WizardNugget"));

var _DrupalWizardNugget = _interopRequireDefault(require("./DrupalWizardNugget.scss"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _index = require("../../../../KESI2/Services/RemoteControlService/index");

var _FeatureManager = _interopRequireDefault(require("../../../../utils/features/FeatureManager"));

var _DrupalNugget = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/DrupalNugget.js"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _QuizNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/QuizNugget"));

var _VoteNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/VoteNugget"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _ErrorHelper = require("../../../../helpers/ErrorHelper");

var _NavigationManagerCordova = _interopRequireDefault(require("../../../../../src/common/NavigationManagerCordova"));

var _PreconditionChecker = require("../../../../utils/PreconditionChecker");

var _icons = require("@material-ui/icons");

var _NonFlippingGenericTiles = require("../NonFlippingGenericTiles");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'swipeContainer_';

var DrupalWizardNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalWizardNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalWizardNugget);

  function DrupalWizardNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalWizardNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goToNextNugget", function () {
      _this.setState({
        nuggetIndex: _this.state.nuggetIndex + 1
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goToPrevNugget", function () {
      _this.setState({
        nuggetIndex: _this.state.nuggetIndex - 1
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "closeNugget", function () {
      var nugget = _this.state.content[_this.props.id];

      _this.onDone(nugget);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToTop", function () {
      var div = document.getElementById(_this.getDomId());

      while (div && div.scrollTop === 0) {
        div = div.parentElement;
      }

      if (div) div.scrollTop = 0;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeIndex", function (index) {
      console.log('wizardNugget onChangeIndex', index);

      _this.setState({
        nuggetIndex: index
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setStepDone", function (isDone) {
      console.log('here wizard nugget, setStepDone: ', isDone);

      _this.setState({
        isStepDone: isDone
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onDone", function (nugget) {
      var datastorepath = nugget.datastorepath,
          isgohomeondone = nugget.isgohomeondone;
      console.log('onDone', datastorepath, isgohomeondone, _this.props.onDoneFn, _this.props.goHomeFn);

      if (_this.props.setWizardArrowFns) {
        _this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.NEXT, null);

        _this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.CLOSE, null);

        _this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.BACK, null);
      }

      if (_this.props.resetScrollIndicatorFn) {
        _this.props.resetScrollIndicatorFn();
      }

      if (datastorepath) {
        _DataStore["default"].setSingleData(nugget.datastorepath, true);
      }

      if (isgohomeondone) {
        if (_this.props.goHomeFn) {
          _this.props.goHomeFn();
        } else {
          _NavigationManagerCordova["default"].goHome();
        }
      }

      if (_this.props.onDoneFn) _this.props.onDoneFn();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "filterNuggets", function (nuggets) {
      var filteredNuggets = [];

      if (!nuggets) {
        return [];
      }

      nuggets.forEach(function (singleNuggetId) {
        var singleNugget = _KESI2Helper["default"].getContentById(singleNuggetId.id);

        if (singleNugget && singleNugget.showPrecondition) {
          var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(singleNugget.showPrecondition);

          if (failingPrecondition) {
            return;
          }
        }

        filteredNuggets.push(singleNuggetId);
      });
      return filteredNuggets;
    });
    _this.state = _objectSpread({
      nuggetIndex: 0,
      waitingForActivation: false,
      isStepDone: true
    }, _this.state);
    _this.active = true;

    _this.props.registerNugget(_this.props.id, _WizardNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalWizardNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    console.log('constructor!');
    _this.myRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(DrupalWizardNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _WizardNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      var nugget = this.state.content[this.props.id];
      var filteredNuggets = this.filterNuggets(nugget.contents);

      if (filteredNuggets.length === 1) {
        this.props.markAsRead(this.props.id);
      }

      if (this.props.setWizardArrowFns) {
        console.log('wizardNugget didmount', filteredNuggets.length);

        if (filteredNuggets.length === 1) {
          this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.CLOSE, this.closeNugget);
          this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.NEXT, null);
          this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.BACK, null);
        } else {
          this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.NEXT, this.goToNextNugget);
          this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.CLOSE, null);
          this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.BACK, null);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalWizardNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }

      var filteredNuggets = this.filterNuggets(nugget.contents);

      if (this.state.nuggetIndex !== prevState.nuggetIndex || this.state.isStepDone !== prevState.isStepDone) {
        if (this.props.setWizardArrowFns) {
          var disabled = !this.state.isStepDone;

          if (this.state.nuggetIndex === 0 && filteredNuggets.length > 1) {
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.NEXT, disabled ? false : this.goToNextNugget);
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.CLOSE, null);
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.BACK, null);
          } else if (this.state.nuggetIndex === filteredNuggets.length - 1 && filteredNuggets.length > 1) {
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.NEXT, null);
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.BACK, this.goToPrevNugget);
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.CLOSE, disabled ? false : this.closeNugget);
          } else if (filteredNuggets.length === 1) {
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.NEXT, null);
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.BACK, null);
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.CLOSE, disabled ? false : this.closeNugget);
          } else {
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.NEXT, disabled ? false : this.goToNextNugget);
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.BACK, this.goToPrevNugget);
            this.props.setWizardArrowFns(_NonFlippingGenericTiles.WIZARD_FN_TYPES.CLOSE, null);
          }
        }

        if (this.props.resetScrollIndicatorFn) {
          this.props.resetScrollIndicatorFn();
        }
      }
    }
  }, {
    key: "nextSlide",

    /*
    componentWillUpdate (newProps, newState) {
      const nugget = newState.content[this.props.id]
       const active = DataStore.pathExists(`${this.props.id}.${this.props.contentPathArray.join(KESI_PATH_DELIMITER)}`, newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES])
        ? newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(KESI_PATH_DELIMITER)]
        : nugget.active
       if (newState.waitingForActivation && active !== this.active) {
        newState['waitingForActivation'] = false
      }
    }
    */
    value: function nextSlide(nuggetLength) {
      var newIndex = this.state.nuggetIndex + 1;

      if (newIndex === nuggetLength - 1) {
        if (!this.props.inSwipeContainer) {
          this.props.markAsRead(this.props.id);
        }
      }

      if (newIndex < nuggetLength) {
        this.setState({
          nuggetIndex: newIndex
        });
      }

      this.scrollToTop();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {WizardNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var filteredNuggets = this.filterNuggets(nugget.contents);
      var isLastNugget = this.state.nuggetIndex === filteredNuggets.length - 1; // const additionalData = this.state.data[DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]
      // const currentNuggetId = nugget && nugget.contents[this.state.nuggetIndex].id
      // const isNuggetRead = additionalData && additionalData.hasOwnProperty(currentNuggetId) && additionalData[currentNuggetId].read

      var isStepDone = this.state.isStepDone;
      console.log('wizardNugget', this.props);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "wizardContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {},
        ref: this.myRef
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        id: "wizardContainer",
        className: "swipeNugget_".concat(this.props.id, " ").concat(nugget.theme, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "wizardNuggetContainer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_DrupalWizardNugget["default"].navigationContainer, " ").concat(innerClassNames)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalWizardNugget["default"].bulletContainer
      }, filteredNuggets.map(function (nugget, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "".concat(nugget.id, "_").concat(index),
          className: _DrupalWizardNugget["default"].nuggetBullet,
          style: {
            backgroundColor: _this2.state.nuggetIndex === index ? _this2.props.lectureBackgroundColor ? _cssConstants["default"].colorMap[_this2.props.lectureBackgroundColor] : _cssConstants["default"].colors.buttonBackground : '#9B9B9B'
          }
        });
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalWizardNugget["default"].nuggetContainer
      }, /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
        disabled: _DeviceInfoHelper["default"].isBrowser() || !isStepDone,
        index: this.state.nuggetIndex,
        onChangeIndex: function onChangeIndex(index, lastIndex) {
          _this2.onChangeIndex(index);
        }
      }, filteredNuggets.map(function (nuggetToMap, index) {
        // not needed for now but maybe useful in the future
        // const nuggetData = KESI2Helper.getContentById(nuggetToMap.id)
        if (_config["default"].prerenderNextWizardNugget && (index < _this2.state.nuggetIndex - 1 || index > _this2.state.nuggetIndex + 1)) {
          // null is not allowed in swipeable views so return an empty div
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: nuggetToMap.id
          });
        } else if (!_config["default"].prerenderNextWizardNugget && index !== _this2.state.nuggetIndex) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: nuggetToMap.id
          });
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          key: nuggetToMap.id,
          style: {
            position: 'relative',
            width: '90%',
            margin: '0 5%'
          }
        }, /*#__PURE__*/_react["default"].createElement(_DrupalNugget["default"], {
          id: nuggetToMap.id,
          path: _this2.props.path,
          registerNugget: _this2.props.registerNugget,
          markAsRead: _this2.props.markAsRead,
          contentPathArray: _this2.props.contentPathArray,
          setStepDone: _this2.setStepDone,
          inWizardContainer: true,
          lectureBackgroundColor: _this2.props.lectureBackgroundColor
        }));
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingBottom: '40px'
        }
      }, _config["default"].showExtraCloseButtonInWizards && isLastNugget ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: 'wizardNextButton',
        className: _DrupalWizardNugget["default"].nextButton,
        disabled: !isStepDone,
        onClick: function onClick() {
          return _this2.onDone(nugget);
        }
      }, 'Fertig') : null, !_config["default"].useArrowsInsteadOfButtonsInWizardNugget ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalWizardNugget["default"].buttonContainer
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: 'wizardNextButton',
        className: isStepDone ? _DrupalWizardNugget["default"].nextButton : _DrupalWizardNugget["default"].nextButtonDisabled,
        disabled: !isStepDone,
        onClick: isLastNugget ? function () {
          return _this2.onDone(nugget);
        } : function () {
          return _this2.nextSlide(filteredNuggets.length);
        }
      }, isLastNugget ? 'Fertig' : 'Weiter'), this.state.nuggetIndex > 0 ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: 'wizardBackButton',
        className: this.state.nuggetIndex === 0 ? _DrupalWizardNugget["default"].backButtonDisabled : _DrupalWizardNugget["default"].backButton,
        disabled: this.state.nuggetIndex === 0,
        onClick: function onClick() {
          _this2.setState({
            nuggetIndex: _this2.state.nuggetIndex - 1,
            isStepDone: true
          });

          _this2.scrollToTop();
        }
      }, 'Zurück') : null) : null)));
    }
  }]);
  return DrupalWizardNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalWizardNugget;
DrupalWizardNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  isInTutorial: _propTypes["default"].bool,
  onDoneFn: _propTypes["default"].func,
  goHomeFn: _propTypes["default"].func,
  lectureBackgroundColor: _propTypes["default"].string,
  setWizardArrowFns: _propTypes["default"].func,
  resetScrollIndicatorFn: _propTypes["default"].func
};
DrupalWizardNugget.defaultProps = {
  id: null
};